const setCSScores = (ctx, event) => {
  if (ctx.getFormats && ctx.getFormats.matchFormat && ctx.getFormats.matchFormat.name === 'bo1') {
    ctx.setScore({
      GamePeriod: event.GamePeriod,
      ScoreHome: event.extra['points-1'],
      ScoreAway: event.extra['points-2'],
      extra: event.extra
    })
  } else {
    ctx.setScore(event)
  }
  ctx.setPeriodScore({
    period: event.GamePeriod,
    value: {
      home: event.extra['points-1'],
      away: event.extra['points-2']
    }
  })
}

export default {
  // 'this' - $store
  byActionType: {

  },
  // 'this' - $store
  byEventType: {
    'MATCH_FORMAT' (event) {
      const { isShootoutSeriesFormat } = this
      const { extra } = event
      const {
        kits,
        matchFormat,
        overtimeFormat,
        timerFormat: firstVersionTimerFormats,
        inverse
      } = extra

      const timerFormat = !firstVersionTimerFormats
        ? {
          inverse,
          resetEachPeriod: true
        }
        : firstVersionTimerFormats

      if (isShootoutSeriesFormat) return

      this.setMatchFormat({
        kits,
        matchFormat,
        overtimeFormat,
        timerFormat
      })
    },
    'FINISH_PERIOD' (event) {
      setCSScores(this, event)
    },
    'ROUND_END' (event) {
      setCSScores(this, event)
    },
    'START_PERIOD' (event) {
      setCSScores(this, event)
    },
    'MATCH_RELOADED' (event) {
      setCSScores(this, event)
    },
    'ROUND_START' (event) {
      setCSScores(this, event)
    }
  },
  // 'this' - tradermode component instance
  // для кастомной логики отображения event
  eventTitles: {

  },
  eventClasses: {

  }
}
